import { RESET_LOADING_STATUS, SET_LOADING_STATUS } from "./types";

export const setLoadingStatus = (payload) => {
  return async (dispatch) => {
    dispatch({
      payload,
      type: SET_LOADING_STATUS,
    });
  };
};

export const resetLoadingStatus = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_LOADING_STATUS,
      payload: {},
    });
  };
};
